import { render, staticRenderFns } from "./call-type.vue?vue&type=template&id=6f7308cc"
import script from "./call-type.vue?vue&type=script&lang=js"
export * from "./call-type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports